module.exports = __webpack_public_path__ + "static/media/J2.18370284.png";